module.exports = __webpack_public_path__ + "static/media/mesonry-cat2-lg-2.8287f1d4.jpg";